import { render } from "./TechDonutChart.vue?vue&type=template&id=c60d7278&scoped=true"
import script from "./TechDonutChart.vue?vue&type=script&lang=js"
export * from "./TechDonutChart.vue?vue&type=script&lang=js"

import "./TechDonutChart.vue?vue&type=style&index=0&id=c60d7278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c60d7278"

export default script